import React from "react";
import { CalendarDay } from "../../calendar/utils";
import { HORIZONTAL_RULE_COLOR } from "../../tokens";
import { useDataDependency } from "../../utils/RemoteDataProvider";
import { PsalmCycleSetting } from "../../utils/settings";
import { LoadingScreen } from "../pray/LoadingScreen";

export const CheckPsalmsRow: React.FC<{
    day: CalendarDay;
    cycle: PsalmCycleSetting;
}> = (props) => {
    const { day, cycle } = props;

    const loadableMorningPsalms = useDataDependency<string[]>({
        type: "proper psalms",
        day,
        psalmCycle: cycle,
        time: "morning",
    });
    const loadableEveningPsalms = useDataDependency<string[]>({
        type: "proper psalms",
        day,
        psalmCycle: cycle,
        time: "evening",
    });

    return (
        <div
            style={{
                borderTop: `1px dashed ${HORIZONTAL_RULE_COLOR}`,
            }}
        >
            {loadableMorningPsalms.state === "loaded" &&
            loadableEveningPsalms.state === "loaded" ? (
                <>
                    <div
                        style={{ display: "flex", padding: 4, fontSize: "90%" }}
                    >
                        <div
                            style={{
                                width: 100,
                            }}
                        >
                            {day.dayOfTheWeek.toLocaleUpperCase()} {day.month}/
                            {day.date}
                        </div>
                        <div style={{ width: 240 }}>
                            {loadableMorningPsalms.value.join("; ")}
                        </div>
                        <div style={{ width: 240 }}>
                            {loadableEveningPsalms.value.join("; ")}
                        </div>
                    </div>
                </>
            ) : (
                <LoadingScreen />
            )}
        </div>
    );
};
